export const environment = {
  production: false,
  apiUrl: 'https://api-dev.southernoracle.co.zw/southern-oracle-self-care',
  championsDevUrl: 'https://api-dev.southernoracle.co.zw/southern-oracle-self-care',
  championsProdUrl: 'https://api-dev.southernoracle.co.zw/southern-oracle-self-care',
  rootUsername: '000000000Z00',
  rootPassword: 'password@2',
};
